const styles = (theme) => ({
	container: {
		display: "flex",
		width: "100%",
		maxWidth: "100%",
		flexDirection: "column",
		gap: 2,
		height: "100%",
		p: "10px",
		borderRadius: "10px",
		height: "500px",
	},
	boxHeader: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		maxWidth: "100%",
		gap: 1,
		alignItems: "center",
		flexWrap: "wrap",
	},
	paperHeader: {
		display: "flex",
		flexGrow: 1,
		gap: 1,
		padding: "8px",
		height: "100%",
		alignItems: "center",
		justifyContent: "center",
		height: "40px",
	},
	loading: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		height: "500px",
	},
	boxHeader: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		gap: 1,
		"@media (max-width: 345px)": {
			flexDirection: "column",
		},
	},
	autocompleteTextField: {
		maxWidth: "60vw",
		"& .MuiOutlinedInput-root": {
			height: "40px",
		},
	},
	boxStatusText: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		borderRadius: "10px",
		alignItems: "center",
	},
	linerProgress: {
		position: "absolute",
		bottom: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	textTitle: { fontSize: "12px", fontWeight: "bold" },
	textStatus: { fontSize: "14px", fontWeight: "bold" },
	boxTooltip: {
		display: "flex",
		flexDirection: "column",
		padding: "8px",
	},
	textTooltip: {
		fontSize: "10px",
		fontWeight: "bold",
		color: theme.palette.mode === "light" && theme.palette.colors.purple.dark,
	},
	boxStatusInterfaces: { display: "flex", flexDirection: "row", gap: 2 },
});

export default styles;
